export const state = () => ({
})

export const mutations = {
}

export const actions = {
  getVideoAccess ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$api.post('nonce', payload)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getBookedSchedule ({ commit }, clinicID) {
    return new Promise((resolve, reject) => {
      this.$api.get(`doctor/calendars/clinic/${clinicID}`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  }
}
